import {useQuery} from '@tanstack/react-query';

import {getUserOnboardingStatuses} from '../api';
import {QUERY__USER_ONBOARDING_STATUSES} from '../queryKeys';

export const useGetUserOnboardingStatuses = (userId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY__USER_ONBOARDING_STATUSES, userId],
    queryFn: () => getUserOnboardingStatuses(userId as string),
    enabled: !!userId,
  });
};
